import { ClientSideDataWrapper } from './ClientSideDataWrapper';

export default ClientSideDataWrapper;
